export default {
  title: 'Luo käyttöönottolinkki',
  steps: {
    select_gateway: 'Valitse maksuyhdyskäytävä',
    copy_link: 'Kopioi linkki',
  },
  select_gateway: {
    description: 'Valitse maksuyhdyskäytävä, jolle haluat luoda pitkäikäisen käyttöönottolinkin.',
  },
  link: {
    proxy_url_label: 'Käyttöönotto-URL',
    expires_label: 'Vanhenee',
    copy_button: 'Kopioi URL',
    copied: 'Kopioitu!',
    description:
      'Jaa tämä URL-osoite kauppiaalle. Se ohjaa yhdyskäytävän käyttöönottosivulle ja pysyy voimassa viimeiseen voimassaolopäivään asti.',
  },
  buttons: {
    next: 'Seuraava',
    back: 'Takaisin',
    done: 'Valmis',
  },
  toasts: {
    create_success: 'Käyttöönottolinkki luotiin onnistuneesti.',
    create_failed: 'Käyttöönottolinkin luominen epäonnistui.',
  },
};
